import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { withRouter } from 'react-router-dom';
import HomeCards from 'components/molecules/homeCards';
import { RouteUtil } from 'utils/RouteUtil';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
//eslint-disable-next-line
import styles from "./styles.scss";

const OwnHome = props => {
  const { rentalData } = props.data;
  const { isMobile, height } = useViewport();

  if (!rentalData) {
    return [];
  }
  const {
    description,
    description_mobile,
    heading,
    image_mobile,
    image_web,
    subHeading,
    tagWord,
  } = rentalData && rentalData.rentalData[0];
  const handleClick = link => {
    RouteUtil.setRouteChange(props, `/homes`);
  };
  return (
    <div className={'outer-container'} style={{ height }} id={'own-home'}>
      {!isMobile ? (
        <Row className={'main-row'}>
          <Col xs={{ span: 11 }} md={{ span: 4, offset: 0 }} className="column">
            <HTMLView tagName={'h1'} className={'title'} html={heading} />
            <HTMLView
              tagName={'p'}
              className={'intro-description'}
              html={description}
            />
            <CallToAction
              text={'Explore Homes'}
              onClick={() => handleClick()}
              className={'explore'}
              mode={'light'}
            />
          </Col>
          <Col
            xs={{ span: 11 }}
            md={{ span: 8, offset: 0 }}
            className={'second-column'}
          >
            <img src={image_web} alt="image" className={'back-image'} />
          </Col>
        </Row>
      ) : (
        <HomeCards
          description={description}
          description_mobile={description_mobile}
          heading={heading}
          image_mobile={image_mobile}
          image_web={image_web}
          subHeading={subHeading}
          tagWord={tagWord}
        />
      )}
    </div>
  );
};
export default withRouter(OwnHome);
